/** 연간시간표 '모든 클래스 동시보기' 설정(워크스페이스별) — localStorage 유지 */

function key(workspaceId: string): string {
  return `cp.annualShowAllClasses.v1.${workspaceId}`;
}

export function loadAnnualShowAllClasses(workspaceId: string): boolean {
  if (!workspaceId) return false;
  try {
    return window.localStorage.getItem(key(workspaceId)) === '1';
  } catch {
    return false;
  }
}

export function saveAnnualShowAllClasses(workspaceId: string, value: boolean): void {
  if (!workspaceId) return;
  try {
    window.localStorage.setItem(key(workspaceId), value ? '1' : '0');
  } catch {
    /* ignore quota */
  }
}
